import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';
import { AuthenticationService } from '../../../core/services/authentication.service';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss']

})
export class AccountDetailsComponent implements OnInit {
  editNameModal: boolean = false;;
  editEmailModal: boolean = false;;
  editphoneModal: boolean = false;;

  msgfinal: string;
  msg: string;
  showemailErrorMsg: boolean = false;
  showemailErrorMsgone: boolean = false;
  firstName: any;
  ErrorMsgone: boolean = false;
  lastName: any;
  ErrorMsgtwo: boolean = false;
  email: any;
  ErrorMsgthree: boolean = false;
  phoneNumber: any;
  ErrorMsgfour: boolean = false;
  userEmail: any;
  userPhone: any;
  name: any;
  name1: any;

  emailMsg: string;
  passw: any;
  gemail: any;
  emailMsgone: string;
  error: any;
  userInfo: any;
  middleName: any;
userNamechangeval:any;
  constructor(public router: Router, public user: UserService, private authservice: AuthenticationService) {
    //this.name = this.authservice.userValue.userProfile.firstName + " " + this.authservice.userValue.userProfile.lastName;
    
  }

  ngOnInit(): void {
    this.getDashboard();
  }


  updateName() {
    var flag = true
    var errormsg = [];

    if (!this.firstName || this.firstName == "") { this.ErrorMsgthree = true; flag = false; errormsg.push('First Name') }
    if (!this.lastName || this.lastName.length <= 0) { this.ErrorMsgtwo = true; flag = false; errormsg.push('Last Name') }
    if (flag == true) {
      if (this.middleName == null) {
        this.middleName = "";
      }
      this.phoneNumber = null;
      this.email = null;

      this.user.updateProfile(this.email, this.firstName, this.lastName, this.middleName, this.phoneNumber)

        .pipe()
        .subscribe(
          data => {
            if (data.success == true) {
              this.authservice.userValue.userProfile.firstName=data.data.firstName;
              this.authservice.userValue.userProfile.lastName=data.data.lastName;
             this.authservice.userNameChange(this.authservice.userValue)
              this.userNamechangeval=this.authservice.userValue;
              this.editNameModal = false;
              this.getDashboard();
              this.router.navigateByUrl('/account-details')
              Swal.fire('Name updated successfully.')
            }
          }, error => {
            //  if(this.baseservice.handleError(error)){
            //handle Exception from Server 404,401
            if (error.status == 400 || error.status == 417) {
              this.error = error.error.data;

            }
            else {


              this.error = "Something went wrong";
            }
          }, () => { });

    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      // Swal.fire("", "Please fill following mandatory field(s)" + "<br>" + this.msgfinal, 'warning')
    }
  }

  fn() {
    if (!this.firstName || this.firstName.length <= 0) { this.showemailErrorMsg = true; }
    else {
      { this.showemailErrorMsg = false; }
    }
  }

  ln() {
    if (!this.lastName || this.lastName.length <= 0) { this.ErrorMsgtwo = true; }
    else {
      { this.ErrorMsgtwo = false; }
    }
  }

  updatePhno() {
    var flag = true
    var errormsg = [];
    if (!this.phoneNumber || this.phoneNumber == "" || this.ErrorMsgfour == true ) 
    { this.ErrorMsgfour = true; flag = false; errormsg.push('Please Enter a Valid Phone Number') }
    if(flag) {
      this.firstName = null;
      this.middleName = null;
      this.lastName = null;
      this.email = null;

      this.user.updateProfile(this.firstName, this.middleName, this.lastName, this.email, this.phoneNumber)
        .pipe()
        .subscribe(
          data => {
            if (data.success == true) {
              this.editphoneModal = false;
              this.getDashboard();
              this.router.navigateByUrl('/account-details')
              Swal.fire('Phone Number updated successfully.')
            }
          }, error => {
            //  if(this.baseservice.handleError(error)){
            //handle Exception from Server 404,401
            if (error.status == 400 || error.status == 417) {
              this.error = error.error.data;

            }
            else {


              this.error = "Something went wrong";
            }
            //  }
          }, () => { });
    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      // Swal.fire("", "Please fill following mandatory field(s)" + "<br>" + this.msgfinal, 'warning')
    }
  }
  error1;isvalidate;
  checkPhone(){
    if(this.phoneNumber!== ""){
    this.isvalidate=  this.validate(this.phoneNumber);
   // if(this.isvalidate){
      this.user.checkphoneNumber(this.phoneNumber).pipe()
      .subscribe(
        data => { 
       if(data.data=="false")
         {
           this.ErrorMsgfour=true
      this.error1="Please Enter a Valid Phone Number";
         }
         else{
          this.ErrorMsgfour=false
           this.error1=null;
         }
        },error=>{
          this.ErrorMsgfour=true
          this.error1="Please Enter a Valid Phone Number";
          if(error.status == 400 || error.status==417){
                this.error=error.error.data;
             }
            },()=>{});
            
   // }
    // else{
    //   this.ErrorMsgfour=true
    //   this.error1="Alphabets are not allowed";
    // }
      }
      else{
        this.ErrorMsgfour=false
        this.error1=null;
      }
  }
  validate(key) {
    //getting key code of pressed key
    var keycode = (key.which) ? key.which : key.keyCode;        
    //comparing pressed keycodes
   if (keycode >= 65 && keycode <= 90) {
        return false;
    }
  }      
  ValidateEmail(cemail) {
    if (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(cemail)) {
      return (true);
    }
    this.showemailErrorMsg = true;
    return (false);
  }
  emailErrorMsg() {

    if (this.ValidateEmail(this.email) == false) {
      this.showemailErrorMsg = true;
      this.emailMsg = "Please enter valid email";
    }
    else {
      this.showemailErrorMsg = false;
    }
  }

  ValidateEmailone(gemail) {
    if (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(gemail)) {
      return (true);
    }
    this.showemailErrorMsgone = true;
    return (false);
  }
  emailErrorMsgone() {

    if (this.ValidateEmail(this.gemail) == false) {
      this.showemailErrorMsgone = true;
      this.emailMsgone = "Please enter valid email";
    }
    else {
      this.showemailErrorMsgone = false;
    }
  }

  updateemail() {
    var flag = true
    var errormsg = [];

    if (!this.email || this.email == "") { this.showemailErrorMsg = true; flag = false; errormsg.push('First Name') }
    if (!this.gemail || this.gemail.length <= 0) { this.showemailErrorMsgone = true; flag = false; errormsg.push('Last Name') }
    if (!this.email == this.gemail) {
      Swal.fire('Email and Confirm Email must be same!');
      flag = false
    }
    if (flag == true) {
      this.firstName = null;
      this.middleName = null;
      this.lastName = null;
      this.phoneNumber = null;

      this.user.updateProfile(this.email, this.firstName, this.lastName, this.middleName, this.phoneNumber)
        .pipe()
        .subscribe(
          data => {
            if (data.success == true) {
              this.editEmailModal = false;
              this.getDashboard();
              this.router.navigateByUrl('/account-details')
              Swal.fire('Email updated successfully.')
            }
          }, error => {

            if (error.status == 400 || error.status == 417) {
              this.error = error.error.data;

            }
            else {


              this.error = "Something went wrong";
            }
            //  }
          }, () => { });

    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      // Swal.fire("", "Please fill following mandatory field(s)" + "<br>" + this.msgfinal, 'warning')
    }
  }
  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          if (data != null || undefined) {
            this.userInfo = data.data.userProfile;
            this.name = this.userInfo.firstName;
            this.name1 = this.userInfo.lastName;
           // this.authservice.userValue.userProfile.firstName=this.userInfo.firstName;
            //this.authservice.userValue.userProfile.lastName=this.userInfo.lastName;
            
            this.userEmail = this.userInfo.email;
            this.userPhone = this.userInfo.phoneNumber;
            this.phoneNumber=this.userInfo.phoneNumber;
            this.firstName=this.userInfo.firstName;
            this.middleName=this.userInfo.middleName;
            this.lastName=this.userInfo.lastName;
           
          }
        }, error => {
          //  if(this.baseservice.handleError(error)){
          //handle Exception from Server 404,401
          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;

          }
          else {

            this.error = "Something went wrong. Please check username and password.";
          }

        }, () => { });

  }
  
}
